function PowerBIPartnerships() {
  return (
    <div style={{ width: "90%", height: "90%" }}>
      <iframe
        title="Partnerships"
        style={{ width: "100%", height: "100%" }}
        src="https://app.powerbi.com/reportEmbed?reportId=7c76c110-17f1-4251-b4ee-cf243b8062e0&autoAuth=true&ctid=5fb461ed-7397-4bdd-9dc6-5db63180bbb1"
        frameborder="0"
        allowFullScreen="true"
      ></iframe>
    </div>
  );
}

export default PowerBIPartnerships;
